<template>
  <v-expansion-panels v-model="panelOpen">
    <v-expansion-panel class="va-expandable-input" readonly>
      <v-expansion-panel-header>
        <div class="d-flex flex-column">
          <div class="va-expandable-input--title">{{ title }}</div>
          <div class="va-expandable-input--subtitle">{{ subTitle }}</div>
        </div>
        <template #actions>
          <v-switch
            @change="emitValue"
            inset
            color="primary"
            class="va-expandable-input--switch"
            :ripple="false"
            v-model="switchValue"></v-switch>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <slot></slot>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  export default {
    name: "VaExpandableInput",
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: "",
      },
      subTitle: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        panelOpen: false,
        switchValue: false,
      };
    },
    beforeMount() {
      this.panelOpen = this.value ? 0 : false;
      this.switchValue = this.value ? true : false;
    },
    methods: {
      emitValue(val) {
        /**
         * Expansion panels work by index, that's why setting the value to 0 opens the panel.
         */
        this.panelOpen = val ? 0 : false;
        this.$emit("input", !!val);
        this.$emit("change", !!val);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../@core/preset/preset/functions.scss";
  @import "../../@core/preset/preset/typography/index.scss";
  .va-expandable-input {
    border: 1px solid get-color("border");
    background-color: get-color("element-bg-100") !important;
    border-radius: 6px;
    &--title {
      @include heading-4();
      color: get-color("headline");
      margin-bottom: 6px;
    }
    &--subtitle {
      @include text-subtitle-2();
      color: get-color("subtitle");
    }
    &--switch {
      margin-top: 0;
      padding: 0;
    }
    &::before {
      box-shadow: none !important;
    }
    &::v-deep {
      .v-expansion-panel-header {
        padding: 16px;
        cursor: default;
      }
      .v-expansion-panel-header__icon {
        align-self: baseline;
        margin: 0;
        .v-input--selection-controls__input {
          margin-right: 0;
        }
      }
    }
  }

  .v-application.theme--light .v-expansion-panel.v-expansion-panel--active {
    box-shadow: none !important;
  }
</style>
